import { CheckIcon } from '@heroicons/react/solid';

const checkBoxRow = ({ register, answers, rowName, validationOptions }) => {

  let allRows = answers.map((answer, index) =>
    <div key={index} className="flex flex-col items-center md:mr-2 justify-end md:w-1/6">
      <div className="text-xs text-center mb-1 md:mb-8">{answer.text}</div>
      <label htmlFor={rowName + "-" + answer.value} className="cursor-pointer flex">
        <div className="shrink-0 relative">
          <input
            {...register(rowName, validationOptions)}
            id={rowName + "-" + answer.value}
            type="checkbox"
            className="nitro-checkbox w-6 h-6 appearance-none bg-white checked:bg-white"
          />
          <CheckIcon className="nitro-check-icon text-nitro-slate h-10 w-10 absolute text-opacity-0 transition" />
        </div>
      </label>
    </div>
  );

  return allRows;

}

export default checkBoxRow;
